import {
  StepConnector,
  stepConnectorClasses,
  StepIconProps,
} from "@mui/material";
import { styled } from "@mui/system";

const DEFAULT_COLOR = "#C9C9C9";

const getCSSVariable = (variable: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(variable).trim();

const CustomStepIcon = ({ active, completed, icon }: StepIconProps) => {
  const isHighlighted = completed || active;
  const STEP_COLOR = getCSSVariable("--primary-color");
  return (
    <div
      style={{
        width: 24,
        height: 24,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: isHighlighted ? "white" : STEP_COLOR,
        backgroundColor: isHighlighted ? STEP_COLOR : "transparent",
        border: isHighlighted ? "none" : `0.75px solid ${STEP_COLOR}`,
      }}
    >
      {icon}
    </div>
  );
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}, &.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: getCSSVariable("--primary-color"),
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 1.5,
    border: 0,
    marginRight: "-8px",
    backgroundColor: DEFAULT_COLOR,
    borderRadius: 1,
  },
}));

export { CustomStepIcon, ColorlibConnector };
